import { useSuspenseQuery } from "@tanstack/react-query";

import { replayClient } from "./replayClient";

export const replayKeys = {
  all: ["replay"] as const,
  visit: (sessionKey: string, visitUuid: string, openStayHours: number) =>
    ["replay", sessionKey, visitUuid, openStayHours] as const,
};

export const useVisitReplay = (
  sessionKey: string,
  visitUuid: string,
  openStayHours: number,
) =>
  useSuspenseQuery({
    queryKey: replayKeys.visit(sessionKey, visitUuid, openStayHours),
    queryFn: () => replayClient.get(visitUuid, openStayHours),
  });
